const isClientSide = () => typeof window !== 'undefined';

export default isClientSide;
